module.exports = __webpack_public_path__ + "img/smile_modal.2bebda80.svg";